import {
  ZONES_REQUESTED,
  ZONES_SUCCESS,
  ZONES_FAILURE,
  ZONE_FIND_REQUESTED,
  ZONE_FIND_SUCCESS,
  ZONE_FIND_FAILURE,
  ZONE_CREATE_REQUESTED,
  ZONE_CREATE_SUCCESS,
  ZONE_CREATE_FAILURE,
  ZONE_UPDATE_REQUESTED,
  ZONE_UPDATE_SUCCESS,
  ZONE_UPDATE_FAILURE,
  ZONE_DELETE_REQUESTED,
  ZONE_DELETE_SUCCESS,
  ZONE_DELETE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  zones: [],
  newZone: null,
  lastPage: false,
  continuationToken: null,
  isFetching: false,
  status: 'waiting',
  errors: null
};

const zones = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case ZONES_REQUESTED:
      return Object.assign({}, state, {
        zones: [],
        newZone: null,
        isFetching: true,
        isUpdating: false,
        isCreating: false,
        lastPage: false,
        continuationToken: null,
        status: 'requested',
        errors: null
      });

    case ZONES_SUCCESS:
      return Object.assign({}, state, {
        zones: action.payload.zones || [],
        lastPage: action.payload.last_page,
        continuationToken: action.payload.continuation_token,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case ZONES_FAILURE:
      return Object.assign({}, state, {
        zones: [],
        isFetching: false,
        status: 'error',
        errors: action.error
      });


    case ZONE_FIND_REQUESTED:
      newState.isFetching = true;
      newState.status = 'requesting';
      newState.activeZone = null;
      return newState;

    case ZONE_FIND_SUCCESS:
      newState.isFetching = false;
      newState.status = 'success';
      newState.activeZone = action.payload;

      return newState;

    case ZONE_FIND_FAILURE:
      newState.isFetching = false;
      newState.status = 'waiting';
      return newState;


    case ZONE_CREATE_REQUESTED:
      newState.isCreating = true;
      newState.newZone = null;
      return newState;


    case ZONE_CREATE_SUCCESS:
      newState.isCreating = false;
      newState.newZone = action.payload;
      return newState;


    case ZONE_CREATE_FAILURE:
      newState.isCreating = false;
      return newState;


    case ZONE_UPDATE_REQUESTED:
      newState.isUpdating = true;
      newState.errors = null;
      newState.newZone = null;
      return newState;

    case ZONE_UPDATE_SUCCESS:
      newState.isUpdating = false;
      newState.newZone = action.payload;
      return newState;

    case ZONE_UPDATE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Could not update zone';
      return newState;


    case ZONE_DELETE_REQUESTED:
      newState.isUpdating = true;
      newState.zones = newState.zones.filter(zone => zone.id.split("#")[1] !== action.zoneId);
      newState.errors = null;
      return newState;

    case ZONE_DELETE_SUCCESS:
      newState.isUpdating = false;
      return newState;

    case ZONE_DELETE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to disable zone';
      return newState;

    default:
      return state;
  }
}

export default zones;
